import { render, staticRenderFns } from "./Dialogs_ReturnList.vue?vue&type=template&id=630ac9f7&scoped=true&"
import script from "./Dialogs_ReturnList.vue?vue&type=script&lang=js&"
export * from "./Dialogs_ReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ac9f7",
  null
  
)

export default component.exports